import { Breadcrumbs, Link } from '@mui/material';
import { styled } from '@mui/system';
import { getRoute } from '@utils';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { capitalizeWord } from '@utils/strings';

interface CategoriesBreadcrumbsProps {
  categorySlug?: string;
  subCategorySlug?: string;
}

const StyledBreadcrumbs = styled(Breadcrumbs)({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  maxWidth: '100%',
  '& .MuiBreadcrumbs-separator': {
    marginLeft: '2px',
    marginRight: '2px',
    flexShrink: 0,
  },
  '& .MuiBreadcrumbs-ol': {
    flexWrap: 'nowrap',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiBreadcrumbs-li': {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    '&:last-child': {
      flexShrink: 1,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'flex',
      alignItems: 'center',
      '& a': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        display: 'inline-block',
      },
    },
  },
});

const StyledLink = styled(Link)({
  fontSize: '12px',
  fontFamily: 'Poppins',
  display: 'inline-block',
});

export function CategoriesBreadcrumbs({
  categorySlug,
  subCategorySlug,
}: CategoriesBreadcrumbsProps) {
  if (!categorySlug) {
    return null;
  }

  return (
    <StyledBreadcrumbs
      separator={<NavigateNextIcon sx={{ fontSize: '0.875rem' }} />}
    >
      <StyledLink
        href={getRoute('home').toString()}
        color="text.secondary"
        underline="hover"
      >
        Página de inicio
      </StyledLink>
      <StyledLink
        href={getRoute('subCategories', { categorySlug }).toString()}
        color={subCategorySlug ? 'text.secondary' : 'text.primary'}
        underline="hover"
      >
        {capitalizeWord(categorySlug)}
      </StyledLink>
      {subCategorySlug && (
        <StyledLink
          href={getRoute('subCategory', {
            categorySlug,
            subCategorySlug,
            page: '1',
            sortBy: 'mostSelling',
          }).toString()}
          color="text.primary"
          underline="hover"
        >
          {capitalizeWord(subCategorySlug)}
        </StyledLink>
      )}
    </StyledBreadcrumbs>
  );
}
